'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import moment from 'moment';
import DefaultModal from 'Modals/DefaultModal';
import Select from 'Components/Forms/Elements/Select';
import DateInput from 'Components/Forms/Elements/DateInput';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import bemit from 'Functions/bemit';
import { b_seminar_ranges, days_config, coworking_place_types } from 'Shared/options';
import { getOpenInfos, num, isTrue } from 'Shared/utilities';
import { action } from 'Shared/Routes';
const {
  app,
  qwest
} = window;
export default class ScheduleDashboardPage extends Component {
  state = {
    date: moment().format(),
    etablishment_id: app.state.session.user?.etablishment || app.state.session.user?._etablishment?.id,
    space_type: 'a_calm_coworking_space',
    fetched_once: false,
    openBookingModal: false,
    status_messages: {}
  };
  booking_modal_ref = React.createRef();
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchSpaces({
      space_type: 'a_calm_coworking_space'
    });
    component.fetchBookings({
      date: moment().format('YYYY-MM-DD')
    });
  }
  componentDidUpdate(prevProps, prevState) {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.space_type && prevState.space_type !== state.space_type) {
      component.fetchSpaces({
        etablishment_id: state.etablishment_id,
        space_type: state.space_type
      });
    }
    if (state.date && prevState.date !== state.date) {
      component.fetchBookings({
        date: state.date
      });
      (state.spaces || []).forEach(function (space) {
        component.getSpaceBooking(space.id);
      });
    }
  }
  fetchSpaces = ({
    etablishment_id,
    space_type
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getSpacesSpaces'), {
      etablishment_id: typeof etablishment_id === 'undefined' ? state.etablishment_id : etablishment_id,
      type: typeof space_type === 'undefined' ? state.space_type : space_type,
      source: 'schedule'
    }).then(function (xhr, response) {
      let spaces = response.data;
      spaces.forEach(function (space) {
        component.getSpaceBooking(space.id);
      });
      let type_options = [];
      coworking_place_types.filter(opt => isTrue(response[opt.value])).forEach(function (opt) {
        type_options.push({
          value: opt.value,
          label: opt.label
        });
      });
      const update = {};
      component.setState({
        ...update,
        loading: false,
        spaces: spaces,
        type_options: type_options,
        fetched_once: true
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  fetchBookings = ({
    date
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/booking/get-all', {
      date: date || state.date
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        booking_list: response.data
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  getSpaceBooking = coworking_space_id => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/booking/get-space-booking', {
      date: state.date,
      coworking_space_id: coworking_space_id
    }).then(function (xhr, response) {
      let booking = response?.booking;
      component.setState({
        bookings: {
          [coworking_space_id]: booking
        }
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  openBookingModal = ({
    e,
    booking_ids_modal
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openBookingModal: true,
      booking_ids_modal: booking_ids_modal,
      booking_modal_trigger: e.target
    });
  };
  closeBookingModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openBookingModal: false,
      booking_ids_modal: [],
      booking_modal_trigger: undefined
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    moment.locale('fr');
    const spaceBookings = (state?.booking_list || []).filter(booking => booking.coworking_space.id === state?.spaces?.[0]?.id);
    let booking_details = (spaceBookings || []).map(function (booking) {
      let output = /*#__PURE__*/React.createElement("div", {
        className: "c-booking-row",
        key: booking.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-booking-row__col"
      }, booking?.start_hour === "afternoon" ? "Après midi" : booking?.start_hour === "morning" ? "Matin" : booking?.start_hour === "day" ? "Journée" : booking?.start_hour + "h - " + booking?.end_hour + 'h'), /*#__PURE__*/React.createElement("div", {
        className: "c-booking-row__col"
      }, booking?.status === 'confirmed' ? undefined : booking?.status === 'paid' ? 'oui' : 'non'), /*#__PURE__*/React.createElement("div", {
        className: "c-booking-row__col"
      }, booking?.number_of_people), /*#__PURE__*/React.createElement("div", {
        className: "c-booking-row__col"
      }, booking?.customer?.lastname, ' ', booking?.customer?.firstname), /*#__PURE__*/React.createElement("div", {
        className: "c-booking-row__col"
      }, booking?.customer?.login), /*#__PURE__*/React.createElement("div", {
        className: "c-booking-row__col"
      }, booking?.customer?.phone_number));
      return output;
    });
    const [min_hours, max_hours] = (state.spaces || []).reduce(function ([min_hours, max_hours], space) {
      const day = days_config[moment(state.date).isoWeekday() - 1];
      const from = num(space.schedule[day]?.from, 0);
      const to = num(space.schedule[day]?.to, 0);
      if (from < min_hours) {
        min_hours = from;
      }
      if (to > max_hours) {
        max_hours = to;
      }
      return [min_hours, max_hours];
    }, [24, 0]);
    let spaces_row = [];
    let interval = max_hours - min_hours;
    if (interval < 0) interval *= -1;
    if (state.space_type === 'b_seminar' || state.space_type === 'c_open_coworking_space') {
      let date = moment(state.date).format('YYYY-MM-DD');
      let spaces_columns = (state.spaces || []).reduce(function (cols, space) {
        const morning_afternoon = b_seminar_ranges.filter(opt => opt.value !== 'day').map(function (seminar_type_opt) {
          let booking_count = (state.bookings?.[space.id] || []).find(function (booking, i) {
            return booking.date === date && booking.type === seminar_type_opt.value;
          });
          let reservedPlaces = 0;
          const filteredBookings = state.bookings?.[space.id];
          for (const obj of filteredBookings || []) {
            if (obj.hasOwnProperty("people_count") && obj.type === seminar_type_opt.value) {
              reservedPlaces += parseInt(obj.people_count);
            }
          }
          const reserved_place = reservedPlaces;
          let first_quarter = num(num(space.number_seat, 0) / 3.33, 0);
          let second_quarter = first_quarter + first_quarter;
          let place_modifiers = [];
          if (space.type === 'b_seminar') {
            place_modifiers.push('green');
          } else {
            if (parseInt(reserved_place, 10) < first_quarter) {
              place_modifiers.push('green');
            } else if (parseInt(reserved_place, 10) >= first_quarter && parseInt(reserved_place, 10) < second_quarter) {
              place_modifiers.push('orange');
            } else {
              place_modifiers.push('red');
            }
          }
          let place = /*#__PURE__*/React.createElement("span", {
            className: bemit('c-place', place_modifiers)
          }, space.type === 'b_seminar' ? 'Libre' : [reserved_place, space.number_seat].join(' / '));
          if (booking_count && space.type === 'b_seminar' || spaceBookings.some(obj => obj.type === "day")) {
            place = /*#__PURE__*/React.createElement("span", {
              className: "c-place c-place--red"
            }, "Reserv\xE9");
          }
          const [is__open, is__custom] = getOpenInfos({
            schedule: space.schedule,
            availability: space.availabilities,
            type: space.type,
            date: date,
            period: seminar_type_opt.value
          });
          if (!is__open) {
            let modifiers = is__custom ? ['manual'] : [];
            modifiers.push('closed');
            place = /*#__PURE__*/React.createElement("span", {
              className: bemit('c-open-date', modifiers)
            }, "Ferm\xE9");
          }
          let output = /*#__PURE__*/React.createElement("div", {
            className: bemit('c-coworking-space__price__row__col', ['schedule']),
            key: space.id + seminar_type_opt.value
          }, booking_count?.booking_id.length > 0 ? /*#__PURE__*/React.createElement(Button, {
            className: "c-btn c-btn--booking",
            onClick: e => component.openBookingModal({
              e: e,
              booking_ids_modal: booking_count.booking_id
            })
          }, place) : place);
          return output;
        });
        return cols.concat([morning_afternoon]);
      }, []);
      let b_seminar_row = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "c-coworking-space c-coworking-space--row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-coworking-space__price__row__col c-coworking-space__price__row__col--schedule c-coworking-space__price__row__col--title"
      }, "Matin"), spaces_columns.map(cols => cols[0])), /*#__PURE__*/React.createElement("div", {
        className: "c-coworking-space c-coworking-space--row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-coworking-space__price__row__col c-coworking-space__price__row__col--schedule c-coworking-space__price__row__col--title"
      }, "Apr\xE8s-midi"), spaces_columns.map(cols => cols[1])));
      spaces_row.push(b_seminar_row);
    } else {
      for (let i = 0; i < interval; i++) {
        let spaces_col = (state.spaces || []).map(function (space) {
          const day = days_config[moment(state.date).isoWeekday() - 1];
          let date = moment(state.date).format('YYYY-MM-DD');
          let place;
          let reserved_place = 0;
          let place_classname = "";
          let first_quarter = space.number_seat / 3;
          let second_quarter = first_quarter + first_quarter;
          const from = parseInt(space.schedule[day]?.from, 10);
          const to = parseInt(space.schedule[day]?.to, 10);
          let booking_count = (state.bookings?.[space.id] || []).find(booking => parseInt(booking.hour, 10) === min_hours + i && booking.date === date);
          if (booking_count) reserved_place = booking_count.people_count;
          if (parseInt(reserved_place, 10) < first_quarter) {
            place_classname = "c-place c-place--green";
          } else if (parseInt(reserved_place, 10) >= first_quarter && parseInt(reserved_place, 10) < second_quarter) {
            place_classname = "c-place c-place--orange";
          } else {
            place_classname = "c-place c-place--red";
          }
          const [is__open, is__custom] = getOpenInfos({
            schedule: space.schedule,
            availability: space.availabilities,
            type: space.type,
            date: date
          });
          const expired = min_hours + i + 1 <= from || min_hours + i >= to;
          if (!is__open || expired) {
            place = /*#__PURE__*/React.createElement("span", {
              className: "c-close-date"
            }, "Ferm\xE9");
          } else {
            place = /*#__PURE__*/React.createElement("span", {
              className: place_classname
            }, reserved_place + ' / ' + space.number_seat);
          }
          let output = /*#__PURE__*/React.createElement("div", {
            className: bemit('c-coworking-space__price__row__col', ['schedule']),
            key: space.id + date + from + to
          }, booking_count?.booking_id.length > 0 ? /*#__PURE__*/React.createElement(Button, {
            className: "c-btn c-btn--booking",
            onClick: e => component.openBookingModal({
              e: e,
              booking_ids_modal: booking_count.booking_id
            })
          }, place) : place);
          return output;
        });
        const schedule_label = min_hours + i + 'h - ' + (min_hours + i + 1) + 'h';
        let row = /*#__PURE__*/React.createElement("div", {
          className: bemit('c-coworking-space', ['row']),
          key: schedule_label
        }, /*#__PURE__*/React.createElement("div", {
          className: bemit('c-coworking-space__price__row__col', ['schedule', 'title'])
        }, schedule_label), spaces_col);
        spaces_row.push(row);
      }
    }
    let header = (state.spaces || []).map(function (space) {
      let output = /*#__PURE__*/React.createElement("div", {
        className: bemit('c-coworking-space__price__row__col', ['schedule', 'date']),
        key: space.id
      }, space.name);
      return output;
    });
    const dashboard_table = !state.fetched_once ? undefined : spaces_row.length > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0 no-horizontal-padding"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space-prices\r c-coworking-space-prices--schedule"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__price c-coworking-space__price--schedule"
    }, state.spaces ? /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__price__row c-coworking-space__price__row--schedule"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-coworking-space__price__row__col c-coworking-space__price__row__col--schedule c-coworking-space__price__row__col--title"
    }), header) : undefined), spaces_row)) : getFormStatus({
      warning: 'Aucun espace pour cette date ou type d\'espace.'
    });
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Disponibilit\xE9s par jour"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--price-dashboard"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element c-filters__element--date"
    }, /*#__PURE__*/React.createElement("strong", null, "Date :"), /*#__PURE__*/React.createElement(DateInput, {
      onChange: component.handleChange,
      value: state['date'],
      label: "",
      className: "c-filters__element__date-input",
      name: "date",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element c-filters__element--type c-filters__element--grouped"
    }, /*#__PURE__*/React.createElement("strong", null, "Type : "), /*#__PURE__*/React.createElement(Select, {
      options: state.type_options || [],
      onChange: component.handleChange,
      key: String(state.type_options?.length),
      value: state['space_type'],
      name: "space_type",
      type: "text",
      label: "",
      status: state.status_messages
    })))), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, dashboard_table), /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.openBookingModal,
      title: "Liste des r\xE9servations",
      trigger_src: state.booking_modal_modal_trigger,
      "close-ref": component.booking_modal_ref,
      "hide-controls": true,
      bemit: ['default', 'large'],
      onClose: component.closeBookingModal
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-modal__body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-booking"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-booking-row c-booking-row--header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-booking-row__col"
    }, "Horaire"), /*#__PURE__*/React.createElement("div", {
      className: "c-booking-row__col"
    }, "Pay\xE9"), /*#__PURE__*/React.createElement("div", {
      className: "c-booking-row__col"
    }, "Nombre de personnes"), /*#__PURE__*/React.createElement("div", {
      className: "c-booking-row__col"
    }, "Client"), /*#__PURE__*/React.createElement("div", {
      className: "c-booking-row__col"
    }, "Email"), /*#__PURE__*/React.createElement("div", {
      className: "c-booking-row__col"
    }, "T\xE9l.")), booking_details))));
    return output;
  }
}
